import { Group, GroupItem, GroupTitle } from "ra-friendsofbabba";
import {
  RadioButtonGroupInput,
  ReferenceInput,
  useTranslate,
} from "react-admin";

import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    "& legend": {
      display: "none",
    },
  },
}));

const DynamicRadioInput = ({
  optionText,
  table,
  sectionTitle,
  filter = {},
  ...props
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Group wrapper>
      <GroupTitle
        title={translate(`resources.user-outputs.section.${sectionTitle}`)}
        subTitle={translate(
          `resources.user-outputs.section.${sectionTitle}.help`
        )}
      />
      <GroupItem lg={12} md={12} sm={12} xs={12}>
        <div className={classes.root}>
          <ReferenceInput
            {...props}
            filter={filter}
            reference={table}
            sort={{ field: "id", order: "ASC" }}
          >
            <RadioButtonGroupInput optionText={optionText} row={false} />
          </ReferenceInput>
        </div>
      </GroupItem>
    </Group>
  );
};
export default DynamicRadioInput;
